module.exports = __webpack_public_path__ + "img/selected7-min.5342be41.png";